export default "__VITE_ASSET__XXpRIwt7__"